/*
 * BBM PLP — mobile filters open expanded.
 *
 * Dawn's mobile Filters drawer is a DRILL-DOWN: each filter group is a
 * <details> whose panel slides in from the right over the group list, with a
 * back button. Jason (Asana 1218587160872793, 2026-09-17): on mobile the
 * groups arrive collapsed, which is a different experience from the desktop
 * sidebar, and he asked for them open.
 *
 * Nothing in Dawn's own JS is modified. `assets/global.js` binds a click
 * handler to EVERY <summary> inside <menu-drawer> (MenuDrawer.bindEvents),
 * and that handler is what starts the drill-down: it adds `menu-opening` to
 * the group, `submenu-open` to the list behind it, and traps focus in the
 * panel. So this script REPLACES each group's summary with a clone, which
 * drops those listeners, and leaves the native <details> toggle in place -
 * the group then behaves as a plain accordion. The matching CSS (in
 * bbym-plp-card.css, under .bbym-facets-expanded) lays the panel out inline
 * instead of as a sliding overlay.
 *
 * Two things undo the work and are re-applied:
 * 1. Closing the drawer strips `open` from every <details> inside it
 *    (MenuDrawer.closeMenuDrawer), so the groups come back collapsed on the
 *    next open. The disclosure's own toggle re-opens them.
 * 2. Filtering re-renders the drawer's markup from the server
 *    (facets.js), which brings back Dawn-bound summaries. A MutationObserver
 *    catches that.
 */
(function () {
  var ROOT = '.bbym-facets-expanded';
  var GROUP = '.mobile-facets__details';

  function expand(wrapper) {
    wrapper.querySelectorAll(GROUP).forEach(function (group) {
      var summary = group.querySelector('summary.mobile-facets__summary');
      // The sort block carries the same class but is a <div> with no summary.
      if (!summary) return;

      if (!summary.dataset.bbymUnbound) {
        var clone = summary.cloneNode(true);
        clone.dataset.bbymUnbound = 'true';
        summary.replaceWith(clone);
        summary = clone;
      }

      group.open = true;
      group.classList.remove('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Left behind if a group was drilled into before this ran.
    wrapper.querySelectorAll('.submenu-open').forEach(function (el) {
      el.classList.remove('submenu-open');
    });
  }

  function watch(wrapper) {
    if (wrapper.dataset.bbymFacetsWatched) return;
    wrapper.dataset.bbymFacetsWatched = 'true';

    expand(wrapper);

    var disclosure = wrapper.querySelector('.mobile-facets__disclosure');
    if (disclosure) {
      disclosure.addEventListener('toggle', function () {
        if (disclosure.open) expand(wrapper);
      });
    }

    new MutationObserver(function () {
      expand(wrapper);
    }).observe(wrapper, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll(ROOT).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * BBM PLP — Price as three range checkboxes (snippets/bbym-price-buckets.liquid).
 *
 * 1. Ticking a box sets the two hidden price inputs in the same form BEFORE
 *    Dawn's form-level 'input' handler (facets.js) reads the form: this
 *    listener is on the capture phase, so it always runs first. The range is
 *    the span from the lowest ticked box to the highest; none ticked clears it.
 *
 * 2. Counts. Shopify gives no per-range count, so each box's count is read
 *    from `?view=bbym-count` (templates/collection.bbym-count.liquid) with
 *    the page's other filters applied and the price range swapped for the
 *    box's own. Filtering re-renders the markup from the server, which
 *    arrives with empty counts; a MutationObserver fills them again. A box
 *    with no products and not ticked is disabled, as the other facets do.
 */
(function () {
  var BUCKET = '[data-bbym-price-bucket]';
  var cache = {};

  document.addEventListener(
    'input',
    function (event) {
      var box = event.target;
      if (!box.matches || !box.matches(BUCKET)) return;
      var form = box.closest('form');
      if (!form) return;
      var ticked = Array.prototype.filter.call(form.querySelectorAll(BUCKET), function (b) {
        return b.checked;
      });
      var gte = form.querySelector('[data-bbym-price-gte]');
      var lte = form.querySelector('[data-bbym-price-lte]');
      if (!gte || !lte) return;
      gte.value = ticked.length ? ticked[0].dataset.gte : '';
      lte.value = ticked.length ? ticked[ticked.length - 1].dataset.lte : '';
    },
    true
  );

  function countUrl(box) {
    var params = new URLSearchParams(window.location.search);
    ['filter.v.price.gte', 'filter.v.price.lte', 'page', 'section_id', 'view'].forEach(function (k) {
      params.delete(k);
    });
    if (box.dataset.gte) params.set('filter.v.price.gte', box.dataset.gte);
    if (box.dataset.lte) params.set('filter.v.price.lte', box.dataset.lte);
    params.set('view', 'bbym-count');
    return window.location.pathname + '?' + params.toString();
  }

  function fill() {
    document.querySelectorAll('[data-bbym-price-counts]').forEach(function (list) {
      if (list.dataset.bbymFilled === window.location.search) return;
      list.dataset.bbymFilled = window.location.search;
      list.querySelectorAll(BUCKET).forEach(function (box) {
        var url = countUrl(box);
        var label = box.closest('label');
        var slot = label && label.querySelector('[data-bbym-price-count]');
        if (!slot) return;
        cache[url] =
          cache[url] ||
          fetch(url, { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.text() : '';
            })
            .then(function (t) {
              var n = parseInt(t.trim(), 10);
              return isNaN(n) ? null : n;
            })
            .catch(function () {
              return null;
            });
        cache[url].then(function (n) {
          if (n === null) return;
          slot.textContent = '(' + n + ')';
          slot.hidden = false;
          var hidden = label.querySelector('.visually-hidden');
          if (hidden) hidden.textContent = hidden.textContent.replace(/ \(.*\)$/, '') + ' (' + n + (n === 1 ? ' product)' : ' products)');
          if (n === 0 && !box.checked) {
            box.disabled = true;
            label.classList.add('disabled');
          }
        });
      });
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fill, 50);
  }

  function start() {
    fill();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
